const findVinPopupWrappers = document.querySelectorAll('.find-notes__popup');

findVinPopupWrappers.forEach((el) => {
    const openFindVinPopupBtn = el.querySelector('.find-notes__popup-btn');
    const findVinPopup = el.querySelector('.find-vin-popup');
    const closeFindVinPopupBtn = el.querySelector('.find-vin-popup__close');

    openFindVinPopupBtn.addEventListener('click', () => {
        findVinPopup.classList.add('show');
    });

    closeFindVinPopupBtn.addEventListener('click', () => {
        findVinPopup.classList.remove('show');
    });
});
